import Vue from "vue";
import { apiRequest, loginRequest, myMSALObj } from "./msalService";

export default {
  async firmar(fileToSign, metadata) {
    let token = null;
    let formData = new FormData();
    formData.append("file", fileToSign);
    formData.append("metadata", metadata);

    if (myMSALObj.getAccount()) {
      return myMSALObj
        .acquireTokenSilent(apiRequest)
        .then((accessTokenResponse) => {
          // get access token from response
          // response.accessToken
          token = accessTokenResponse.accessToken;
          const bearer = `Bearer ${token}`;
          return Vue.axios({
            method: "post",
            url: "api/firma-documento",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: bearer,
            },
          });
        })
        .catch((err) => {
          // could also check if err instance of InteractionRequiredAuthError if you can import the class.
          if (err.name === "InteractionRequiredAuthError") {
            return myMSALObj
              .acquireTokenRedirect(apiRequest)
              .then((accessTokenResponse) => {
                token = accessTokenResponse.accessToken;
                const bearer = `Bearer ${token}`;
                return Vue.axios({
                  method: "post",
                  url: "api/firma-documento",
                  data: formData,
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: bearer,
                  },
                });
              });
          } else {
            return Promise.reject(err.response);
          }
        });
    } else {
      // user is not logged in, you will need to log them in to acquire a token
      myMSALObj.loginRedirect(loginRequest);
    }
  },
};
